<template>
  <div>
    <agile
      ref="carousel"
      class="agile"
      :nav-buttons="false"
      :dots="false"
      :autoplay-speed="6000"
      :speed="2500"
      fade
      autoplay
      centerMode
    >
      <!-- eslint-disable-next-line prettier/prettier -->
      <img
        v-for="item in slides"
        :key="item.id"
        class="slide"
        :src="item.img"
        :alt="item.alt"
        :style="cssProps"
      />
    </agile>
    <button @click="$refs.carousel.goToNext()" class="costbtn next">
      <img src="@/assets/icons/ico-chevron-right.svg" alt="" />
    </button>
    <button @click="$refs.carousel.goToPrev()" class="costbtn prev">
      <img src="@/assets/icons/ico-chevron-left.svg" alt="" />
    </button>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile';

export default {
  name: 'Carouzel',
  props: {
    slides: {
      type: Array,
      required: true,
    },
    slideHeight: {
      type: String,
      default: '85',
    },
  },
  computed: {
    cssProps() {
      return {
        '--height': `${this.slideHeight}vh`,
      };
    },
  },
  components: {
    agile: VueAgile,
  },
};
</script>

<style scoped lang="scss">
// VueAgile styles

img {
  width: 100%;
}

.agile {
  position: relative;
  /*  CLIP - PATH  */
  // -webkit-clip-path: polygon(0 0, 100% 0%, 100% 83%, 0% 100%);
  // clip-path: polygon(0 0, 100% 0%, 100% 83%, 0% 100%);
  z-index: 0;
}

.costbtn {
  border: none;
  position: absolute;
  top: 300px;
  color: white;
  font-size: 40px;
  background-color: rgba(0, 0, 0, 0.541);
  cursor: pointer;
  transition-duration: 0.3s;
  padding: 4px 8px;
  z-index: 100;
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 25px;
    height: auto;
  }
}

.next {
  right: 10px;
  // height: 50%;
}

.prev {
  left: 10px;
}

.costbtn:focus {
  outline: none;
}

.slide {
  display: block;
  height: var(--height);
  width: 100%;
  object-fit: cover;
  width: 100%;
}

@media (max-width: 900px) {
  .agile {
    width: 100%;
  }
}
</style>
